import { PAYMENTS } from "constants/payments";
import { BrandButton } from "components/brand";

export const MarkAsPaid = ({ disabled, handleAction }) => {
  return (
    <BrandButton
      variant="primary"
      className="mark_as_paid_btn"
      disabled={disabled}
      onClick={handleAction}
    >
      {PAYMENTS.mark_as_paid}
    </BrandButton>
  );
};
